import { gql, TypedDocumentNode } from "@apollo/client";

import { Maybe, PullRequest, QueryStackArgs, Stack } from "types/generated";
import { PickInner } from "types/helpers";

export type StackPullRequestItem = Pick<
  PullRequest,
  "id" | "authorLogin" | "createdAt" | "headBranch" | "headBranchURL" | "title" | "url"
> & {
  runs: PickInner<PullRequest["runs"], "id" | "state" | "title" | "createdAt" | "delta">;
};

export type StackPullRequestRunItem = StackPullRequestItem["runs"][number];

type ListPullRequestsData = {
  stack: Maybe<Pick<Stack, "id"> & { pullRequests: StackPullRequestItem[] }>;
};

export const LIST_PULL_REQUESTS: TypedDocumentNode<ListPullRequestsData, QueryStackArgs> = gql`
  query ListPullRequests($id: ID!) {
    stack(id: $id) {
      id
      pullRequests {
        id
        authorLogin
        createdAt
        headBranch
        headBranchURL
        runs {
          id
          createdAt
          delta {
            addCount
            changeCount
            deleteCount
            resources
            importCount
            forgetCount
            moveCount
            ignoreCount
            okCount
            rescueCount
            skipCount
            unreachableCount
            failedCount
          }
          state
          title
        }
        title
        url
      }
    }
  }
`;
